import React from 'react';
import { FiMinus, FiPlus } from 'react-icons/fi';

import { Text, textVariantsEnum, fontWeightEnum } from '@components/Text';

import styles from './CounterStepper.module.scss';

export const CounterStepper = ({
  value,
  onChange,
  min = 0,
  max = 365,
  step = 1,
  unitLabel,
  disabled,
}) => {
  const decrement = () => onChange?.(Math.max(min, value - step));
  const increment = () => onChange?.(Math.min(max, value + step));

  return (
    <div className={styles.card}>
      <button
        type="button"
        className={styles.stepButton}
        onClick={decrement}
        disabled={disabled || value <= min}
        aria-label="Decrease"
      >
        <FiMinus size={18} />
      </button>
      <div className={styles.valueStack}>
        <Text
          variant={textVariantsEnum.Display_sm}
          fontWeight={fontWeightEnum.Bold}
          color="indigo-600"
        >
          {value}
        </Text>
        {unitLabel && (
          <Text
            variant={textVariantsEnum.Text_sm}
            fontWeight={fontWeightEnum.Semibold}
            color="gray-800"
          >
            {unitLabel}
          </Text>
        )}
      </div>
      <button
        type="button"
        className={styles.stepButton}
        onClick={increment}
        disabled={disabled || value >= max}
        aria-label="Increase"
      >
        <FiPlus size={18} />
      </button>
    </div>
  );
};

CounterStepper.displayName = 'CounterStepper';
